import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import React, { Component } from "react";

export class EditButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span
        className="edit"
        onClick={this.onClick.bind(this)}
        style={{
          cursor: "pointer",
          fontSize: "small",
          display: "flex",
          textTransform: "capitalize",
        }}
      >
        <Tooltip title="Edit" classes={{ popper: "custom-tooltip" }} arrow>
          <EditIcon
            style={{
              borderRadius: "25%",
              color: "#6A7B8E",
              fontSize: "small",
              width: "30px",
              minHeight: "30px",
              padding: "3px",
            }}
          />
        </Tooltip>
        {/* <h6 style={{ margin: "auto 0px" }}> Edit</h6> */}
      </span>
    );
  }
}
export default EditButton;
